import React from 'react'
import {
  Link,
  matchPath,
  useLocation,
  useParams,
} from 'react-router-dom'
import { useAppSelector } from '../redux/hooks'
import { isOptiRateAmendmentOffered } from '../util/optiRateAmendment'

// Demo navigation follows the same order as the progress bar.
const buildRoutes = (isLegacy: boolean, showOptiRateStep: boolean): string[] => [
  '/:prospectId/',
  '/:prospectId/business',
  '/:prospectId/agreements/tesa',
  ...(showOptiRateStep ? ['/:prospectId/agreements/optirate-amendment'] : []),
  '/:prospectId/agreements/supplement',
  ...(isLegacy ? ['/:prospectId/agreements/payment'] : []),
  '/:prospectId/finish',
]

const getMostSpecificRouteIndex = (routes: string[], pathname: string): number => {
  for (let i = routes.length - 1; i >= 0; i--) {
    if (matchPath({ path: routes[i], end: true }, pathname)) {
      return i
    }
  }
  return -1
}

const DemoMode = (): JSX.Element => {
  const { pathname } = useLocation()
  const { prospectId } = useParams<{ prospectId: string }>()
  const prospect = useAppSelector((state) => state.app.prospect)
  const isLegacy = (prospect?.tesaVersion ?? 0) < 6
  const showOptiRateStep =
    prospectId === 'demo-optirate' &&
    prospect != null &&
    isOptiRateAmendmentOffered(prospectId, prospect)
  const routes = buildRoutes(isLegacy, showOptiRateStep)

  const currentRouteIndex = getMostSpecificRouteIndex(routes, pathname)
  const getRouteByIndex = (index: number): string =>
    routes[index]?.replace(':prospectId', prospectId!)

  return (
    <div className="sticky top-0 z-10 min-h-10 w-full max-w-[1200px] text-white text-center mx-auto font-normal text-base bg-king-blue">
      <div className="grid grid-cols-[120px_auto_120px] h-full">
        {currentRouteIndex !== 0 ? (
          <Link
            to={getRouteByIndex(currentRouteIndex - 1)}
            className="border-0 bg-king-red text-white font-normal text-base py-2.5 px-0 no-underline flex flex-col justify-center hover:text-white"
          >
            <span>Previous</span>
          </Link>
        ) : (
          <div />
        )}
        <div className="self-center h-full p-2.5">Demo Mode</div>
        {currentRouteIndex !== routes.length - 1 && (
          <Link
            to={getRouteByIndex(currentRouteIndex + 1)}
            className="border-0 bg-king-red text-white font-normal text-base py-2.5 px-0 no-underline flex flex-col justify-center hover:text-white"
          >
            <span>Next</span>
          </Link>
        )}
      </div>
    </div>
  )
}

export default DemoMode
